import Helpers from '../modules/Helpers'
import Map, { streetLayer } from '../modules/Map'

if (document.getElementsByClassName('owners-contact').length) {
    
    new Helpers(document.getElementById('showMap')).eventListener((e) => {
        if (this.map === undefined) {
            /**
             * Initialise the map
             * use a small timeout to ensure the panel is visible first
            **/
            setTimeout(() => {
                this.map = new Map('map', {
                    center: [50.72, -3.53], zoom: 7,
                }, {
                    'Streets': streetLayer(),
                })

                /**
                 * Add marker to the map, where the user clicked and set a hidden value
                **/
                this.map.map.on('click', (data) => {
                    this.map.clearMarkers()
                    this.map.addMarker(data.latlng)
                    document.getElementsByClassName('owners-contact__latlng')[0].value = data.latlng.lat + "," + data.latlng.lng
                })

                /**
                 * Remove the marker icon (and clear the hidden value)
                **/
                new Helpers(document.getElementById('clearMarker')).eventListener((e) => {
                    e.preventDefault()
                    this.map.clearMarkers()
                    document.getElementsByClassName('owners-contact__latlng')[0].value = ''
                })


            }, 100)
        }
    })
    
}